import { CircularProgress, Stack, Typography } from '@mui/joy'
import React from 'react'

type Props = {}

const LoadingCircular = (props: Props) => {
  return (
    <Stack
      direction="column"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "60vh" }}
    >
      <CircularProgress size="lg" />
      <Typography level="body-lg" color="neutral">
        Loading ...
      </Typography>
    </Stack>
  )
}

export default LoadingCircular